export async function deleteShippingGuidesUseCase(guide_ids, guideRepostitory) {
    const result = await guideRepostitory.delete_guides(guide_ids);

    return result;
}